module.exports = __webpack_public_path__ + "c12a18212d865d24711d8bbeb2ecd345.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/planet-saturn-s.png
// module id = 1909
// module chunks = 0